import { ref } from "@vue/composition-api";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";

export const useCreditCardAssignment = () => {
  const { authUser } = useAuthUser();
  const creditCards = ref<CreditCardAssignment[]>([]);

  const getCreditCardAssignment = async () => {
    if (!authUser.value) return;
    creditCards.value = await providers.CreditCardAssignmentsProvider.findAll({ userId: authUser.value.id });
  };

  const getCreditCardsBySystemId = (systemId: string): CreditCardAssignment | undefined => {
    return creditCards.value.filter(i => i.paymentSystemId === systemId)[0];
  };

  return { creditCards, getCreditCardAssignment, getCreditCardsBySystemId };
};
